<template>
  <Card
    v-if="showNudge"
    :class="$style.cardWrapper"
  >
    <div :class="$style.closeWrapper">
      <ButtonClose
        :data-test-id="$testId('closeButton')"
        @click="closeNudge"
      />
    </div>
    <div>
      <HeadingLarge :class="$style.heading">
        Introducing JumpCloud Password Manager
      </HeadingLarge>
      <ParagraphBody :class="[$style.text, $style.topParagraph]">
        No master passwords,
      </ParagraphBody>
      <ParagraphBody :class="[$style.text, $style.topParagraph]">
        decentralized storage architecture.
      </ParagraphBody>
      <img
        :class="$style.image"
        src="img/growth/password-manager-nudge.png"
      >
      <ParagraphBody :class="$style.text">
        Securely manage and share passwords without having to rely on vulnerable master passwords.
        Passwords are stored locally and are synced in an end-to-end encrypted manner across
        devices.
      </ParagraphBody>
      <Button
        :data-test-id="$testId('goToPasswordManagerButton')"
        hasOutline
        :text="$options.giveItATryText"
        type="secondary"
        @click="goToPasswordManager"
      />
    </div>
  </Card>
</template>

<script>
import {
  Button,
  ButtonClose,
  Card,
  HeadingLarge,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  ItemTypeRoutes,
  LocalStorageConsts,
  LoginModalConsts,
} from 'client/util/Constants';
import { UiEvents } from '@jumpcloud/ui-events-vue';
import { mapGetters, mapState } from 'vuex';
import Cookies from 'js-cookie';
import LocalStorageService from 'client/util/LocalStorageService';
import MspState from 'client/components/models/MspState';
import Util from 'client/util/Util';

const { excludeModalTestingCookie } = LoginModalConsts;
const { passwordManagerNudgeDismissed } = LocalStorageConsts;

export default {
  name: 'PasswordManagerNudge',

  giveItATryText: 'Give It A Try',
  LocalStorageService,
  Util,

  components: {
    Button,
    ButtonClose,
    Card,
    HeadingLarge,
    ParagraphBody,
  },

  data() {
    return {
      showNudge: false,
    };
  },

  computed: {
    ...mapState('SettingsModule', [
      'isCustomer',
      'user',
    ]),

    ...mapGetters('PasswordManagerModule', {
      isEnabled: 'getPasswordManagerStatus',
    }),

    isVisible() {
      const excludeTesting = !!Cookies.get(excludeModalTestingCookie);
      let isNudgeDismissed = LocalStorageService.getItem(passwordManagerNudgeDismissed);
      isNudgeDismissed = isNudgeDismissed ? JSON.parse(isNudgeDismissed) : null;

      return this.user.sessionCount > 1
        && !this.isCustomer
        && !this.isEnabled
        && !isNudgeDismissed
        && !MspState.isAnMsp
        && !excludeTesting;
    },
  },

  created() {
    if (this.isVisible) {
      setTimeout(() => {
        this.showNudge = true;
        UiEvents.triggerNudgeViewed({
          description: 'Password Manager Nudge viewed',
          displayLogic: 'Visible after first login and password manager is not configured',
          page: this.$page,
        });
      }, 30000);
    }
  },

  methods: {
    closeNudge() {
      this.dismiss();
      UiEvents.triggerIconClicked({
        description: 'Closes nudge for password manager',
        iconName: 'close',
        page: this.$page,
        section: 'Password Manager Nudge',
      });
    },

    dismiss() {
      LocalStorageService.setItem(passwordManagerNudgeDismissed, true);
      this.showNudge = false;
    },

    goToPasswordManager() {
      const passwordmanagerLink = ItemTypeRoutes[ItemTypeConsts.passwordManager];

      this.dismiss();
      UiEvents.triggerButtonClicked({
        description: 'Opens the password manager page',
        page: this.$page,
        section: 'Password Manager Nudge',
        toUrl: passwordmanagerLink,
        text: this.$options.giveItATryText,
      });

      this.$options.Util.redirect(passwordmanagerLink);
    },
  },
};
</script>

<style scoped module>
.cardWrapper.cardWrapper.cardWrapper {
  background-color: var(--jcPrimary700);
  border-radius: var(--jc-spacer-x-small);
  border-style: none;
  bottom: 0;
  position: fixed;
  transition: all var(--jc-transition-duration) var(--jc-transition-function);
  width: 24rem;
  z-index: 600;
}

.closeWrapper {
  position: absolute;
  right: var(--jc-spacer);
  top: var(--jc-spacer);
}

.heading.heading.heading {
  margin-top: var(--jc-spacer-medium);
}

.image {
  margin-bottom: var(--jc-spacer-small);
  width: 100%;
}

.topParagraph.topParagraph.topParagraph {
  margin-bottom: 0;
}

.text.text.text {
  font-size: var(--jcBodyLarge);
}
</style>
